import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "px-4 pb-8 mt-4 border-b border-gray-400" }
const _hoisted_13 = { class: "mt-2 space-y-2" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = {
  class: "inline-block pl-[0.15rem] capitalize",
  for: "checkboxDefault"
}
const _hoisted_16 = { class: "flex justify-center px-4 py-3 bg-gray-50" }

import { Template } from "@/types";
import { ref, PropType, onMounted, onUnmounted } from "vue";
import DefaultButton from "../DefaultButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableCountriesModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  template: {
    type: Object as PropType<Template>,
    required: false,
  },
  countries: {
    type: Array as PropType<string[]>,
    required: true,
  },
},
  emits: ["close", "select"],
  setup(__props, { emit: emits }) {

const props = __props;




const selectedCountries = ref([] as string[]);

function close() {
  emits("close");
}

function addCountryToSelected(e: Event) {
  const country = (e.target as HTMLInputElement).nextElementSibling?.textContent;

  if (selectedCountries.value.find(i => i === country)) {
    selectedCountries.value = selectedCountries.value.filter(i => i !== country);
  } else {
    selectedCountries.value.push(country);
  }
}

function addCountries() {
  emits(
    "select",
    selectedCountries.value.filter(i => i !== undefined)
  );
}

function isCountrySelected(country: string) {
  if (props.countries.find(i => i === country)) return true;
  return false;
}

onMounted(() => {
  if (props.countries) {
    selectedCountries.value = Array.from(props.countries);
  }
});

onUnmounted(() => {
  selectedCountries.value = [];
});

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("available-countries")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t("select-country")), 1),
                  _createElementVNode("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.template?.countries, (country, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "block space-x-2",
                        key: index
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          onChange: addCountryToSelected,
                          class: "rounded hover:cursor-pointer",
                          checked: isCountrySelected(country.country)
                        }, null, 40, _hoisted_14),
                        _createElementVNode("label", _hoisted_15, _toDisplayString(country.country), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(DefaultButton, {
                  type: "primary",
                  onAction: addCountries,
                  disabled: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("save-selected-country")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})